import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Navigator from './Navigator';
import Header from './Header';
import ChatWidget from '../components/Chat/ChatWidget';
import { colorTheme } from '../styles/MaterialTheme';

let theme = {
    ...colorTheme,
    shape: {
        borderRadius: 8,
    },
    mixins: {
        toolbar: {
            minHeight: 57,
        },
    },
    components: {
        MuiTab: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 4,
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    width: 32,
                    height: 32,
                },
            },
        },
    },
};

const drawerWidth = 256;

type TemplateProps = {
    menuActive: string,
    children?: React.ReactNode
}

export default function Templete({ menuActive, children } : TemplateProps) {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [infoLogin] = React.useState(JSON.parse(String(sessionStorage.getItem('infoLogin'))))
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                <CssBaseline />
                <Box
                    component="nav"
                    sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                >
                    {isSmUp ? null : (
                        <Navigator
                            PaperProps={{ style: { width: drawerWidth } }}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            menuActive={menuActive}
                        />
                    )}
                    <Navigator
                        PaperProps={{ style: { width: drawerWidth } }}
                        sx={{ display: { sm: 'block', xs: 'none' } }}
                        menuActive={menuActive}
                    />
                </Box>
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                    <Header onDrawerToggle={handleDrawerToggle} infoLogin={infoLogin} />
                    <Box component="main" sx={{ flex: 1, py: 1, px: 1, bgcolor: '#eaeff1', overflow: 'hidden' }}>
                        {children}
                    </Box>
                </Box>
            </Box>
            <ChatWidget />
        </ThemeProvider>
    );
}